import type { VatCompanyAddress } from '~~/types/vatValidation';
import { isRegistryPostalCodeOptional } from '~~/helpers/vatValidation/isRegistryPostalCodeOptional';
import { POSTAL_CODE_FIELD } from '~~/types/checkout/PostalCodeCartError';

export const VAT_AUTOFILL_ADDRESS_FIELDS: Array<keyof VatCompanyAddress> = [
  'company',
  'streetName',
  'additionalAddressInfo',
  POSTAL_CODE_FIELD,
  'city',
];

export const hasRegistryAddressToValidate = (address?: Record<string, unknown> | null): boolean => {

  return Boolean(address?.id) && VAT_AUTOFILL_ADDRESS_FIELDS.some(field => address?.[field]);

};

/**
 * On markets where registry might not carry a postal code we can not treat missing postal code as a failed validation
 * and we need to ignore it when comparing the addresses.
 */
export const isFieldUnanswered = (
  field: keyof VatCompanyAddress,
  validationAddress: VatCompanyAddress,
): boolean =>
  field === POSTAL_CODE_FIELD
  && !validationAddress[POSTAL_CODE_FIELD]
  && isRegistryPostalCodeOptional(validationAddress.country);

export const getAddressMismatch = (address: Record<string, unknown>, validationAddress: VatCompanyAddress) => {

  const mismatches: Partial<Record<keyof VatCompanyAddress, string>> = {};

  for (const field of VAT_AUTOFILL_ADDRESS_FIELDS) {

    if (isFieldUnanswered(field, validationAddress)) {

      continue;

    }

    if (String(address[field] ?? '') !== String(validationAddress[field] ?? '')) {

      mismatches[field] = String(validationAddress[field] ?? '');

    }

  }

  return mismatches;

};
